import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';
import { filter, get, isString, map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getDirectionWarehouse } from '../../../thunks/direction-thunks';

interface DirectionsSelectProps extends SelectProps {
  className?: string;
  organization?: string | number;
  error?: boolean;
  helperText?: string;
  InputProps?: Record<string, any>;
  prompt?: boolean | string;
}

export const DirectionsSelect: ComponentType<DirectionsSelectProps> = ({
  organization,
  label,
  error = false,
  helperText,
  InputProps,
  prompt,
  ...props
}) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { warehouse } = useSelector((state: RootStateOrAny) => state.direction);

  const value = String(get(props, 'value', ''));
  const list = organization ? filter(warehouse.hits, (x) => x.organization === organization) : [];
  const options = map(list, (item, idx) => (
    <MenuItem value={get(item, 'id', '')} key={idx}>
      {get(item, ['description', i18n.language === 'oz' ? 'uz' : i18n.language], 'None')}
    </MenuItem>
  ));

  if (prompt) {
    options.unshift(
      <MenuItem value="" key="prompt">
        {isString(prompt) ? prompt : t('action.select', 'Выбрать')}
      </MenuItem>
    );
  }

  useEffect(() => {
    dispatch(getDirectionWarehouse());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl error={error} fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select {...{ ...props, label, value }}>{options}</Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
